// plugins/device.client-server.ts
import { useBreakpoints } from '@vueuse/core'
import detectDeviceType from '~/utils/detect-device'
import type { DeviceType } from '~~/shared/types/app'

export default defineNuxtPlugin((_nuxtApp) => {

    const device = useState<DeviceType>('device', () => 'desktop')

    // Server-side detection
    if (import.meta.server) {
        const event = useRequestEvent()
        const ua = event?.node.req.headers['user-agent'] || ''
        device.value = detectDeviceType(ua)
    }

    // Client-side reactive detection
    if (import.meta.client) {
        const breakpoints = useBreakpoints({ mobile: 0, tablet: 768, desktop: 1025 })
        const isMobile = breakpoints.smaller('tablet')
        const isTablet = breakpoints.between('tablet', 'desktop')

        watchEffect(() => {
            if (isMobile.value) device.value = 'mobile'
            else if (isTablet.value) device.value = 'tablet'
            else device.value = 'desktop'
        })
    }

    return {
        provide: {
            device,
        },
    }
})
